import React, { createContext, useContext, useState, useEffect, useMemo, useCallback } from 'react'
import { useScreenersContext } from './useScreenersContext'
import useScreenerFilters from '../hooks/useScreenerFilters'
import useDatasetsList from '../../../hooks/useDatasetsList'
import { merge, formatDecimal, capitalize } from '../../../utils/tools'
import { useGeneral } from '../../../context/general'
import useFetchPost from '../../../hooks/useFetchPost'
import useScreener from '../hooks/useScreener'
import axios from 'axios'


const ScreenerContext = createContext()

export const ScreenerContextProvider = ({uuid, name, children }) => {
    const { projects, checkIfProjectExist, handleOpenProject, projectMethods } = useGeneral()
    const { initColumns, chipsLabels, datasetFormat, watchlistField, LimtOnField } = useScreener(projects, handleOpenProject, projectMethods, checkIfProjectExist)
    const [ limitsOn, setLimitsOn] = useState({label:'',value:''})
    const [ data, setData ] = useState()
    const [ filters, setFilters ] = useState()
    const [ basicColumns, setBasicColumns ] = useState(initColumns)
    const { updatedScreenersList } = useScreenersContext()
    const [TopBottomLimitOPtions, setTopBottomLimitOPtions] = useState([])

    // const columns = useMemo(() => projects ? [watchlistField, ...basicColumns, LimtOnField] : []  ,[projects, basicColumns]) // eslint-disable-line
    const columns = useMemo(() => (projects !=[] & limitsOn?.value !='') ? [watchlistField, ...basicColumns, LimtOnField] : projects ? [watchlistField, ...basicColumns] : [] ,[projects,limitsOn, basicColumns]) // eslint-disable-line

    const { selectRole, initAlternativeField, initFinancialKPIField } = useScreenerFilters()
    const [ modalSectorsList, setModalSectorsList ] = useState([])
    const [ modalFinancialKPI, setModalFinancialKPI ] = useState([initFinancialKPIField])
    const [ modalDataset, setModalDataset ] = useState([initAlternativeField])
    const [ modalMarketCap, setModalMarketCap ] = useState([])
    const [ modalExchange, setModalExchange ] = useState([])
    const [ modalMicCode, setModalMicCode] = useState([])
    const [ topLimit, setTopLimit] = useState(null)
    const [ bottomLimit, setBottomLimit] = useState(null)
    

    const isEmpty = useMemo(() => !(filters && Object.keys(filters)?.some(key => filters[key]?.length)) ,[filters])

    const { updateDataset } = useDatasetsList(modalDataset)
    const filtersBody = useMemo(() => ({filters, uuid}) ,[filters, uuid])
    const { data: response, isLoading } = useFetchPost(!isEmpty && `/api/getScreenerData?uuid=${uuid}`, filtersBody)

    const handleFinancileKPISelect = (data, index) => {
        const copy = [...modalFinancialKPI]
        copy[index][data.name] = data.value
        setModalFinancialKPI(copy)
    }

    const getRoleName = (data) =>{
        const name = selectRole.filter(item=> item.value == data.rule)
        return name[0]['name']
    }

    const getAlternativeDataChipName = (data) => {
        const ruleText = `${formatDecimal(data.change.change)}% ${data.rule === "between" ? `- ${formatDecimal(data.change.change1)}%` : ''}`
        return `${data.datasetName} - ${data.columnName} : ${getRoleName(data)} ${ruleText} - ${capitalize(data.forTimeperiod)}`
    }

    const getFinancialDataChipName = (data) => {
        const ruleText = `${formatDecimal(data.change.change)}% ${data.rule === "between" ? `- ${formatDecimal(data.change.change1)}%` : ''}`
        return `${data.KPI} : ${getRoleName(data)} ${ruleText} - ${capitalize(data.forTimeperiod)}`
    }
    
    const getLimitsDataChipName = (data)=>{
        const Text = `${data.limitsOn['label']} : ${data.top?`Top - ${data.top}`:''} ${data.top?data.bottom?`&`:'':''} ${data.bottom?`Bottom - ${data.bottom}`:''}`
        return [Text]
    }

    useEffect(() => {
        setFilters()
        if(uuid){
            axios.get(`/api/getCurrentScreener?uuid=${uuid}`)
            .then(res => res.data)
            .then(res => {
                const { sector, dataset, exchange, market_cap: market_cap, financial_kpi:financial_kpi, mic_code,top,bottom,limitsOn } = res.data
                setLimitsOn(limitsOn)
                setFilters({sector, dataset, exchange, market_cap,financial_kpi,mic_code, top, bottom,limitsOn})
                market_cap.length == 0 && removeTopBottomLimitsOnOptions('market_cap')
                if (financial_kpi){
                    setModalFinancialKPI(financial_kpi)
                }
            })
        }
        return () => {}
    },[uuid]) // eslint-disable-line

    const chips = useMemo(() => {
        if(!filters) return []
        const chipFormat = {...filters, dataset: filters?.dataset?.map(data => getAlternativeDataChipName(data)),financial_kpi: filters?.financial_kpi?.map(data=>getFinancialDataChipName(data)),limitsOn:filters?.limitsOn?.value?getLimitsDataChipName(filters):[]}
        return Object.keys(chipFormat).filter(key => chipFormat[key]?.length).map(key => ({name: chipsLabels[key], key, value: chipFormat[key]}))
    },[filters, chipsLabels])

    useEffect(() => {
        let updatedColumns = filters?.dataset.map(element => datasetFormat(element)) ?? []
        const sectorIndex = initColumns.findIndex(column => column.field === 'sector') + 1
        setBasicColumns(merge(initColumns, updatedColumns, sectorIndex))
        return () => {}
    } ,[filters]) // eslint-disable-line

    const handleSavingFilters = (filters) => {
        // fetch('/screener/savingFilters', {
        //     method: 'POST',
        //     headers: { 'Content-Type': 'application/json' },
        //     body: JSON.stringify({filters, uuid})
        // })
        axios({
            method:"POST",
            url: "/screener/savingFilters",
            data: {filters, uuid}
        })
        .then(res => res.json())
        .then(res => res.status === 200 && setFilters(filters))
    }

    const handleUpdateFilters = () => {
        const cleanDataset = modalDataset?.filter(data => data.datasetValue && data.columnValue )
        const cleanFinancialKPI = modalFinancialKPI?.filter(data => data.KPI)
        const limits_On = limitsOn?limitsOn:{label:'',value:''}
        const top = limitsOn?topLimit:null
        const bottom = limitsOn?bottomLimit:null
        const filtersFormat = {dataset: cleanDataset, sector: modalSectorsList, exchange: modalExchange, market_cap: modalMarketCap, financial_kpi:cleanFinancialKPI,mic_code:modalMicCode,top:top,bottom:bottom,limitsOn:limits_On}
        handleSavingFilters(filtersFormat)
    }

    const handleRemoveFilter = (key,value='') =>  {
        let tempFilters =filters
        if (key=="financial_kpi"){
            let ChipValue = value[0].split(' :')[0]
            if (limitsOn['label'] == ChipValue){
                updateTopBottomLimitOn({label:'',value:''});
                updateTopBottom({name:'top',value:null});
                updateTopBottom({name:'bottom',value:null});
                tempFilters['limitsOn'] = {label: '', value: ''}
                tempFilters['top'] = null
                tempFilters['bottom'] = null
            }
            }
        else if(key=='market_cap'){
            if (limitsOn['value']=='market_cap'){
                updateTopBottomLimitOn({label:'',value:''})
                updateTopBottom({name:'top',value:null})
                updateTopBottom({name:'bottom',value:null})
                tempFilters['limitsOn'] = {label: '', value: ''}
                tempFilters['top'] = null
                tempFilters['bottom'] = null
            }
        }
        else if (key == 'dataset'){
            value.map(subitem=>{
                let ChipValue = subitem.split(' :')[0]
                if (limitsOn['label'] == ChipValue){
                    updateTopBottomLimitOn({label:'',value:''});
                    updateTopBottom({name:'top',value:null});
                    updateTopBottom({name:'bottom',value:null});
                    tempFilters['limitsOn'] = {label: '', value: ''}
                    tempFilters['top'] = null
                    tempFilters['bottom'] = null
                }
            })
        }

        if (key=='limitsOn'){
            setLimitsOn({label:'',value:''})
            setTopLimit(null)
            setBottomLimit(null)
            tempFilters['top'] = null
            tempFilters['bottom'] = null
            handleSavingFilters({...tempFilters, [key]:{'label':'','value':''}})
        }
        else{
            handleSavingFilters({...tempFilters, [key]:[]})
        } 
    }
    
    const updateModalForam = useCallback(({sector, dataset, market_cap, exchange,FinancialKPI,mic_code,top,bottom,limitsOn}) => {
        setModalDataset(dataset?.length ? dataset : [initAlternativeField])
        setModalFinancialKPI(FinancialKPI?.length ? FinancialKPI : [initFinancialKPIField])
        setModalSectorsList(sector)
        setModalMarketCap(market_cap)
        setModalExchange(exchange)
        setModalMicCode(mic_code)
        setTopLimit(top)
        setBottomLimit(bottom)
        setLimitsOn(limitsOn)
    },[]) // eslint-disable-line

     useEffect(() => {filters && updateModalForam({...filters});return () => {}},[filters, updateModalForam])

    // modal functions

    //sectors
    const updateSectorList = (value) => setModalSectorsList(value)

    //dataset
    const addAlternativeData = () => setModalDataset(data => ([...data ,initAlternativeField]))

    //Financial KPIs
    const addFinancialKPIData = () => setModalFinancialKPI(data => ([...data ,initFinancialKPIField]))

    const removeFinancialKPIData = (index) => {setModalFinancialKPI(modalFinancialKPI.filter((item, i) => i !== index))}

    const handleUpdateDataset =  useCallback((index, data) => updateDataset && setModalDataset(updateDataset(index, data)), [updateDataset])

    const handleUpdateSelect = (data, index) => {
        const copy = [...modalDataset]
        if (copy) copy[index][data.name] = data.value
        setModalDataset(copy)
    }


    const handleUpdateColumns = (updatedColumns) =>{
        setBasicColumns(updatedColumns)
    }

    const updateModalMarketCap = (value) => {
        setModalMarketCap(value);
        let tempOptions = TopBottomLimitOPtions
        // // tempOptions = [...tempOptions, {'label':'Market Cap','value':'market_cap'}]
        const uniqueArray = tempOptions.filter((item, index, self) => index === self.findIndex(t => t.value === item.value));
        value.length>0?setTopBottomLimitOPtions(uniqueArray):removeTopBottomLimitsOnOptions('market_cap')
    }
    const updateModalExchange = (value) => setModalExchange(value)
    const updateModalMicCode = (value) => setModalMicCode(value)
    const updateTopBottom = (data) =>{
        if (data.name == "top")setTopLimit(data.value)
        if (data.name == 'bottom')setBottomLimit(data.value)
    }
    const updateTopBottomLimitOn = (data)=>{
        data&&setLimitsOn(data)
    } 
    const updateTopBottomLimitOnOptions = (data) => {
        if (data){
            let tempOptions = TopBottomLimitOPtions
            tempOptions = [...tempOptions, ...data]
            const ModalDataSetValue = modalDataset.map(x=> x.columnValue)
            tempOptions = tempOptions.filter((item,index) => ModalDataSetValue.includes(item.value) )
            const uniqueArray = tempOptions.filter((item, index, self) => index === self.findIndex(t => t.value === item.value));
            setTopBottomLimitOPtions(uniqueArray)
        }
    }

    const removeTopBottomLimitsOnOptions = (data) =>{
        setTopBottomLimitOPtions(items => items.filter(item=> item.value!=data))
        // if (data = 'price')setTopBottomLimitOPtions(items => items.filter(item=> item.value!='price'))
        // else if (data = 'market_cap')setTopBottomLimitOPtions(items => items.filter(item=>item.value!='market_cap'))
    }

    //rename
    const handleUpdateScreenerName = async (name) => {
        // const status = await fetch('/api/renameScreener', {
        //     method: 'POST',
        //     headers: { 'Content-Type': 'application/json' },
        //     body: JSON.stringify({name, uuid})
        // })
        const status = await axios({
            method: 'POST',
            url: '/api/renameScreener',
            data: {name, uuid: uuid}
        })
        status.status === 200 && updatedScreenersList(name, uuid)
    }

    useEffect(() => {
        projects && setData(response?.data?.map(row =>  ({...row, isInWatchlist: checkIfProjectExist(row.symbol)})))
        return () => {}
    },[response, projects, checkIfProjectExist])

    return (
        <ScreenerContext.Provider value={{
            handleUpdateFilters,
            columns,
            filters,
            handleUpdateScreenerName,
            name,
            data: data ?? [],
            isLoading: !filters || isLoading || (response && !data),
            isEmpty,
            modalSectorsList,
            modalDataset,
            modalFinancialKPI,
            topLimit,
            bottomLimit,
            limitsOn,
            TopBottomLimitOPtions,
            updateSectorList,
            updateTopBottom,
            updateTopBottomLimitOn,
            addAlternativeData,
            addFinancialKPIData,
            removeFinancialKPIData,
            handleUpdateDataset,
            handleUpdateSelect,
            handleFinancileKPISelect,
            chips,
            handleRemoveFilter,
            modalMarketCap,
            modalExchange,
            updateModalExchange,
            modalMicCode,
            updateModalMicCode,
            updateModalMarketCap,
            updateTopBottomLimitOnOptions,
            removeTopBottomLimitsOnOptions,
            handleUpdateColumns,
        }}>
            { children}
        </ScreenerContext.Provider>
    )

}

export function useScreenerContext() {
    return useContext(ScreenerContext)
}